module.exports = {"350212001":"大同街道","350212002":"祥平街道","350212105":"莲花镇","350212106":"新民镇","350212107":"洪塘镇","350212108":"西柯镇","350212109":"汀溪镇","350212110":"五显镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350212.json
// module id = 1287
// module chunks = 0